<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="nombreEntidad"
    icono="verified"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close(false)"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (!fechaAlta) {
      <app-info-banner
        icon="info"
        [title]="data.alarma ? 'Alarma sin alta' : 'Vehículo sin alta'"
        [message]="
          '<strong>Estado actual:</strong> Todos los eventos generados por' +
          (data.alarma ? ' esta alarma' : ' este vehículo') +
          ' son atendibles.<br><br>
          <strong>Al dar de alta:</strong> Sólo serán atendibles los eventos de acuerdo a la configuración de las categorías asignadas a los mismos.<br><br>
          Seleccioná la fecha de alta y cargá las imágenes correspondientes para completar el proceso.'
        "
        color="orange"
        margin="0 0 12px 0"
      ></app-info-banner>
    } @else {
      <app-info-banner
        icon="check_circle"
        [title]="
          data.alarma
            ? 'Alarma con alta registrada'
            : 'Vehículo con alta registrada'
        "
        [message]="
          '<strong>Estado:</strong> Los eventos de' +
          (data.alarma ? ' esta alarma' : ' este vehículo') +
          ' son atendibles según la configuración de categorías asignadas.<br><br>
          Podés actualizar las imágenes de alta si es necesario.'
        "
        color="green"
        margin="0 0 12px 0"
      ></app-info-banner>
    }

    <!-- Fecha -->
    <app-content-card title="Fecha de alta" icon="event">
      @if (!fechaAlta) {
        <!-- Selector mientras la fecha aún no fue cargada -->
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Fecha de alta</mat-label>
            <input
              readonly
              matInput
              [owlDateTime]="dt1"
              [selectMode]="'single'"
              [max]="maxDate"
              [(ngModel)]="selectedFechaAlta"
            />
            <button
              irxBotonIcono
              tooltip="Elegir fecha"
              tono="primario"
              matSuffix
              [owlDateTimeTrigger]="dt1"
              type="button"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
          </mat-form-field>
          <owl-date-time #dt1></owl-date-time>
        </section>
      } @else {
        <div class="dae-datos">
          <span class="dae-etiqueta">Fecha de alta</span>
          <span class="dae-valor">
            {{ fechaAlta | date: 'dd/MM/yyyy HH:mm' }}
          </span>
        </div>
      }
    </app-content-card>

    <!-- Imágenes -->
    <app-content-card title="Imágenes de alta" icon="photo_library">
      <app-upload-file
        [(urls)]="urlImagenes"
        textoBoton="Subir imágenes"
        [allowMultiple]="true"
        [maxFiles]="4"
      ></app-upload-file>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="dialogRef.close(false)"
      [disabled]="loading"
    >
      Cancelar
    </button>

    @if (fechaAlta) {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="loading"
      >
        <mat-icon>check</mat-icon>
        Actualizar
      </button>
    } @else {
      <button
        irxBoton="principal"
        type="button"
        (click)="onSubmit()"
        [disabled]="!selectedFechaAlta || loading"
      >
        <mat-icon>event_available</mat-icon>
        Dar de alta
      </button>
    }
  </mat-card-actions>
</mat-card>
